import React, {ReactNode} from "react"
import {ContentBannerContainer} from "./components"

export type StandardContentBannerContainerProps = {
    children: ReactNode
}
export const StandardContentBannerContainer = ({children}: StandardContentBannerContainerProps) => {
    return <ContentBannerContainer>{children}</ContentBannerContainer>
}

export default StandardContentBannerContainer
